import * as React from 'react';
import DataTable from "react-data-table-component";
import {Button} from 'reactstrap';
//import {deselectPosition, selectPosition} from "../job/FinishedJobComponent";

interface ICardProps {
  data: any[];
  columns: any[];
  selected: any[];
  inMutant: any[];
  showSelectAll?: false;

  setSelectedRows: (selectedRows: any[]) => void;

  addToCustomMutant: (selectedRows: any[]) => void;
}

function AncestralsTable(props:ICardProps) {

 const prepareAncestralData = (data) => {
    var dataList = {};
    var nodesList = [];
    var dataOut = [];

    data.forEach((residue) => {
        var nodes = residue.ancestrals.split(",");
        nodes.forEach((node) => {
            if(node in dataList){
                dataList[node].push(residue);
            }
            else{
                dataList[node] = [];
                dataList[node].push(residue);
                nodesList.push(parseInt(node));
            }
        });
    });

    nodesList.sort(function(a,b){return a-b;});

    var counter = 0;
    nodesList.forEach((node) => {
        dataOut.push({
            node: String(node),
            distance: counter,
            mutNum: dataList[String(node)].length,
            data: dataList[String(node)]
        });
        counter++;
    });

    console.log(dataOut);
    return dataOut;
 }

  const handleChange = ({ selectedRows }) => {
    const prevSelectedRows = props.selected ?? [];
    if (selectedRows.length === 0 && prevSelectedRows.length === 0) {
      return;
    }
    if (selectedRows.length === prevSelectedRows.length) {
      const same = selectedRows.every(r => prevSelectedRows.includes(r));
      if (same) {
        return;
      }
    }
    props.setSelectedRows(selectedRows);
  };

  const rowSelectCritera = (row) => {
   return props.selected.includes(row);
  };


  const addToMutant = (row) => {
    props.addToCustomMutant(row);
        console.log('clicked',row);
    };

  const ExpandedComponent = ({ data }) => <DataTable
                                                columns={[...props.columns[1], 
                                                    {
                                                      name: "Add to Design",
                                                      cell: (row) => <Button style={{width: "70%",}} onClick={() => addToMutant(row)} disabled={props.inMutant.some(m => m.chain === row["chain"] && m.position === row["position"])} >+</Button>,
                                                      ignoreRowClick: true,
                                                      button: true,
                                                    }
                                          ]}
                                                data={data.data}
                                                dense
                                                highlightOnHover={true}
                                                selectableRows
                                                onSelectedRowsChange={handleChange}
                                                selectableRowSelected={rowSelectCritera}
                                            />

  return (
    <>

      <DataTable
        columns={props.columns[0]}
        data={prepareAncestralData(props.data)}
        pagination
        highlightOnHover={true}
        expandableRows expandableRowsComponent={ExpandedComponent}
      />
    </>
  );
    
}

export default AncestralsTable;

